// 標註範例 — 直接內建於前端，不寫入資料庫。
// 想新增範例時，於此陣列加一筆即可。

export interface LabelExample {
  event_id: number;
  video_url: string;
  time_seconds: number;
  video_duration: number;
  note?: string;
}

export const LABEL_EXAMPLES: LabelExample[] = [
  {
    event_id: 207415926,
    video_url:
      'https://dataweb.theomnieyes.com/api/static?filepath=/data_platform/omnieyes/MKT/events/SID-001/videos/E381AAE381ABE3828F-330-E3818B-38-58_20260101_004153_566_20260101_004206_562.mp4',
    time_seconds: 1.81,
    video_duration: 14.006043,
  },
  {
    event_id: 207418862,
    video_url:
      'https://dataweb.theomnieyes.com/api/static?filepath=/data_platform/omnieyes/MKT/events/SID-001/videos/E381AAE381ABE3828F-530-E38182-36-80_20260101_005530_327_20260101_005547_982.mp4',
    time_seconds: 9.997,
    video_duration: 18,
  },
  {
    event_id: 207434889,
    video_url:
      'https://dataweb.theomnieyes.com/api/static?filepath=/data_platform/omnieyes/MKT/events/SID-001/videos/E7A68FE5B2A1-530-E38182-32-54_20260101_014730_342_20260101_014741_094.mp4',
    time_seconds: 4.699999,
    video_duration: 12.005333,
  },
];
